const DEFAULT_ALL_RECENT_AND_CURRENT_SERVICES = {
    schedules: [],
    recommendations: [],
    requiredServices: [],
};

export default DEFAULT_ALL_RECENT_AND_CURRENT_SERVICES;
